import { NavLink } from 'react-router-dom';
import { Monitor } from 'lucide-react';
import {
  LayoutDashboard,
  TrendingUp,
  Brain,
  Receipt,
  Activity,
  Power,
  Database,
  FlaskConical
} from 'lucide-react';

const nav = [
  { to: '/',                icon: LayoutDashboard, label: 'Overview'     },
  { to: '/strategies',      icon: TrendingUp,       label: 'Estrategias'  },
  { to: '/decisions',       icon: Brain,            label: 'Decisiones'   },
  { to: '/trades',          icon: Receipt,          label: 'Trades'       },
  { to: '/gym',             icon: Database,         label: 'Gym — Datos'  },
  { to: '/gym/backtests',   icon: FlaskConical,     label: 'Gym — Tests'  },
  { to: '/monitor', icon: Activity, label: 'Monitor' },
];
export default function Layout({ children }) {
  return (
    <div className="flex h-screen bg-[#0A0A0F] overflow-hidden">

      {/* ── Sidebar ───────────────────────────────────────────── */}
      <aside className="w-56 flex flex-col border-r border-[#1E1E2E] bg-[#13131A] shrink-0">

        {/* Logo */}
        <div className="px-5 py-6 border-b border-[#1E1E2E]">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
            <span className="font-display font-800 text-amber-500 tracking-widest text-sm uppercase">
              Claudio
            </span>
          </div>
          <p className="text-[10px] text-slate-500 mt-1 font-mono">Trading Agent v2</p>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded text-sm transition-all duration-150 ${
                  isActive
                    ? 'bg-amber-500/10 text-amber-400 border border-amber-500/20'
                    : 'text-slate-400 hover:text-slate-200 hover:bg-white/5'
                }`
              }
            >
              <Icon size={15} />
              <span className="font-mono">{label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Status footer */}
        <div className="px-4 py-4 border-t border-[#1E1E2E]">
          <div className="flex items-center gap-2">
            <Activity size={12} className="text-green-400" />
            <span className="text-[11px] text-slate-500 font-mono">Sistema activo</span>
          </div>
          <div className="flex items-center gap-2 mt-1">
            <Power size={12} className="text-slate-600" />
            <span className="text-[11px] text-slate-600 font-mono">FTMO Demo</span>
          </div>
        </div>
      </aside>

      {/* ── Main content ──────────────────────────────────────── */}
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>

    </div>
  );
}